import { LayoutPageSystemView } from "./layout/index";
import { RouterItemType } from "@/app/module/router/index";

export const routerPageSystemView: RouterItemType = {
  path: "/delegate",
  authorize: true,
  element: <LayoutPageSystemView />,
};
